import { render, staticRenderFns } from "./List.vue?vue&type=template&id=0820e1a2&"
import script from "./List.vue?vue&type=script&lang=js&"
export * from "./List.vue?vue&type=script&lang=js&"
import style0 from "./List.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JG\\jg\\IWMS5.0\\SRM\\GIT\\SRM.VUE\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0820e1a2')) {
      api.createRecord('0820e1a2', component.options)
    } else {
      api.reload('0820e1a2', component.options)
    }
    module.hot.accept("./List.vue?vue&type=template&id=0820e1a2&", function () {
      api.rerender('0820e1a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DeliveryNote/OutsourcingOrderReport/List.vue"
export default component.exports